import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

class PremiumCartCount extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.controller) return;
    this.controller = new AbortController();
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate, { signal: this.controller.signal });
    window.addEventListener('pageshow', this.onPageShow, { signal: this.controller.signal });
  }

  onCartUpdate = async (event) => {
    const version = this.version = (this.version || 0) + 1;
    try {
      const result = await event.promise;
      if (version !== this.version || !this.isConnected || result?.detail?.didError) return;
      this.renderCount(result?.cart?.totalQuantity ?? result?.detail?.itemCount);
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[premium-cart-count] Cart update failed:', error);
    }
  };

  onPageShow = async (event) => {
    if (!event.persisted) return;
    const version = this.version = (this.version || 0) + 1;
    try {
      const response = await fetch(this.dataset.cartUrl + '.js', { signal: this.controller.signal });
      if (!response.ok) return;
      const cart = await response.json();
      if (version === this.version && this.isConnected) this.renderCount(cart.item_count);
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[premium-cart-count] Cart refresh failed:', error);
    }
  };

  renderCount(count) {
    if (!Number.isInteger(count) || count < 0) return;
    const counter = this.querySelector('[data-cart-count]');
    if (counter) counter.textContent = String(count);
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    this.version = (this.version || 0) + 1;
    super.disconnectedCallback();
  }
}

if (!customElements.get('premium-cart-count')) customElements.define('premium-cart-count', PremiumCartCount);
